// extracted by mini-css-extract-plugin
export default {"green":"QNCP1yENbdtpo3FP_E_Z","selected":"EJzcm1Izzdf1Ljav8E79","goodDay":"Yd6harr0tkKdSJzlY8y8","blue":"i257u8i_lBiH4eelZNsQ"};